<template>
    <div class="divider">
        <label class="contentLabel" for="backgroundColor">{{ $t('Add.General.BackgroundColor') }}</label>
        <div class="color-container">
        <input type="color" id="backgroundColor" name="backgroundC" v-model="backgroundColor" />
        <span v-if="backgroundColor" class="material-symbols-outlined reset-color" @click="resetColor">refresh</span>
        <div v-else class="add-color-overlay">+</div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['sharedData'],
    computed:{
    backgroundColor: {
      get() {
        return this.sharedData?.data?.style?.backgroundColor || null;
      },
      set(value) {
        if (!this.sharedData.data.style) {
          this.sharedData.data.style = {};
        }
        this.sharedData.data.style.backgroundColor = value;
      },
    },
    },
    methods: {
        resetColor() {
            this.backgroundColor = null;
        }
    }
}
</script>

<style>
@import '../../../styles/addComponents.css';
</style>